import React, { useState } from "react";
import ListItemLink from "./Listitem/ListItemLink";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import { useStyles } from "../MuiCSS/MiniDrawerStyles";

export const drawerWidth = 340;

const classes = useStyles;

const ListItemLinkContainer = ({ menuObj, openSideBar }) => {
  const [isOpen, setOpen] = useState(false);
  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <React.Fragment>
      {menuObj.submenu.length > 0 ? (
        <ListItemLink
          key={menuObj.id}
          to={menuObj.path}
          menuText={menuObj.menuName}
          icon={menuObj.icon}
          open={isOpen}
          tooltip={menuObj.tooltip}
          openSideBar={openSideBar}
          onClick={handleClick}
        />
      ) : (
        <ListItemLink
          key={menuObj.id}
          to={menuObj.path}
          openSideBar={openSideBar}
          tooltip={menuObj.tooltip}
          menuText={menuObj.menuName}
          icon={menuObj.icon}
        />
      )}

      <Collapse component="li" in={isOpen} timeout="auto" unmountOnExit>
        <List disablePadding component="div">
          {menuObj.submenu.map((sub, index) => (
            <ListItemLink
              spacing={!openSideBar ? 24 : 36}
              key={sub.id}
              to={sub.path}
              tooltip={sub.tooltip}
              openSideBar={openSideBar}
              menuText={sub.menuName}
              icon={sub.icon}
              className={classes.nested}
            />
          ))}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default ListItemLinkContainer;
